import { render, staticRenderFns } from "./Certificados.vue?vue&type=template&id=ad0aa968&scoped=true"
import script from "./Certificados.vue?vue&type=script&lang=js"
export * from "./Certificados.vue?vue&type=script&lang=js"
import style0 from "./Certificados.vue?vue&type=style&index=0&id=ad0aa968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0aa968",
  null
  
)

export default component.exports